import { render, staticRenderFns } from "./Cargos.vue?vue&type=template&id=060d0fa6&scoped=true&"
import script from "./Cargos.vue?vue&type=script&lang=js&"
export * from "./Cargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d0fa6",
  null
  
)

export default component.exports